import { render, staticRenderFns } from "./AdminVehicles.vue?vue&type=template&id=797f4020&scoped=true"
import script from "./AdminVehicles.vue?vue&type=script&lang=js"
export * from "./AdminVehicles.vue?vue&type=script&lang=js"
import style0 from "./AdminVehicles.vue?vue&type=style&index=0&id=797f4020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f4020",
  null
  
)

export default component.exports